import { render, staticRenderFns } from "./MovieContentsDialog.vue?vue&type=template&id=00ae0141&scoped=true&"
import script from "./MovieContentsDialog.vue?vue&type=script&lang=ts&"
export * from "./MovieContentsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MovieContentsDialog.vue?vue&type=style&index=0&id=00ae0141&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ae0141",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
